/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vam: NonNullable<unknown> }} Ui_Rail_VamInputs */

const en_ui_rail_vam = /** @type {(inputs: Ui_Rail_VamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`↗ ${i?.vam} m/h`)
};

const de_ui_rail_vam = /** @type {(inputs: Ui_Rail_VamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`↗ ${i?.vam} m/h`)
};

/**
* | output |
* | --- |
* | "↗ {vam} m/h" |
*
* @param {Ui_Rail_VamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_vam = /** @type {((inputs: Ui_Rail_VamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_VamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_vam(inputs)
	return de_ui_rail_vam(inputs)
});